import { Text, VStack } from "@chakra-ui/react"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"

function UnavailableGroup() {
  const { school } = usePathwrightContext()
  return (
    <VStack minH="200px" w="100%" px={4} justify="center">
      <Text textAlign="center">
        The group linked to was archived or is no longer visible. If you have
        questions, contact {school.name} support.
      </Text>
    </VStack>
  )
}

export default UnavailableGroup
